import { Box } from 'grommet';
import { observer } from 'mobx-react-lite';
import { FooterNav, HeaderNav } from '/src/components';
import AdminSideNav from '/src/components/admin/AdminSideNav';
import { CreditCalculationCard } from '/src/components/admin/CreditCalculationCard';
import { Text } from '/src/components/common';

const FuseAdminCreditCalculation = observer(() => {
  return (
    <Box height={{ min: '100vh' }} background="light" style={{ display: 'flex', flexDirection: 'column' }}>
      <HeaderNav />
      <Box flex="grow" style={{ display: 'flex', flexDirection: 'row', minHeight: 0 }}>
        <AdminSideNav />
        <Box flex="grow" pad={{ horizontal: 'large', vertical: 'medium' }} overflow="auto">
          <Box flex={false}>
            <Box
              direction="row"
              align="center"
              justify="between"
              margin={{ vertical: 'medium' }}
              pad={{ horizontal: 'small' }}
            >
              <Text size="xlarge" weight="normal">
                Credit Calculation
              </Text>
            </Box>
            <CreditCalculationCard />
          </Box>
        </Box>
      </Box>
      <Box flex={false}>
        <FooterNav />
      </Box>
    </Box>
  );
});

export default FuseAdminCreditCalculation;
